import React, { FC } from 'react';
import { Container } from 'react-bootstrap';

import './ClTitle.scss';

interface ClTitleProps {
  titleNumber: string;
  title: string;
  subTitle: string;
}

const ClTitle: FC<ClTitleProps> = ({ titleNumber, title, subTitle }) => {
  return (
    <Container
      fluid
      className="cl-title d-flex flex-column justify-content-center align-items-center"
      data-aos="fade-up"
      data-aos-duration="1000"
    >
      <p className="sub-title">{subTitle}</p>
      <h2 className="title">
        <span>{titleNumber}.</span>
        {title}
      </h2>
    </Container>
  );
};

export default ClTitle;
